import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class SigningProcessConsumer extends Entity<SigningProcessConsumer> {
    @Expose({ name: 'displayName' })
    displayName!: string

    @Expose({ name: 'status' })
    status!: string

    @Expose({ name: 'signedAt' })
    signedAt?: string
}
